import type * as React from "react"
import colorHelper from "@digits-shared/helpers/colorHelper"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import {
  useVibrantBackground,
  type VibrantBackgroundColors,
} from "src/shared/components/Elements/VibrantBackground"

const DEFAULT_CONTAINER_COLORS: VibrantBackgroundColors = {
  backgroundColor: colors.transparent,
  textColor: colors.white,
}

/*
  STYLES
*/

const CoverColors = styled.div<{
  backgroundColor?: string
  textColor?: string
}>`
  --report-cover-background: ${({ backgroundColor }) =>
    backgroundColor ? colorHelper.hexToRgba(backgroundColor, 0.4) : colors.transparent};
  --report-cover-color: ${({ textColor }) => textColor ?? colors.white};

  @media print {
    & {
      --report-cover-background: ${colors.transparent};
      --report-cover-color: ${colors.black};
    }
  }
`

/*
  COMPONENTS
*/

export const ReportCoverColors: React.FC<
  React.PropsWithChildren<{ className?: string; thumbUrl?: string | undefined }>
> = ({ className, thumbUrl, children }) => {
  const { backgroundColor, textColor } = useVibrantBackground(thumbUrl, DEFAULT_CONTAINER_COLORS)

  return (
    <CoverColors className={className} backgroundColor={backgroundColor} textColor={textColor}>
      {children}
    </CoverColors>
  )
}
